import Plot from 'react-plotly.js'
import Plotly from 'plotly.js/dist/plotly'
import PropTypes from 'prop-types'
import React from 'react'
import cloneDeep from 'lodash/cloneDeep'

class FirContentPlotter extends React.Component {
  constructor(props) {
    super(props)

    this.onAutoSize = this.onAutoSize.bind(this)
  }

  render() {
    const data = this.props.data

    if (data) {
      const curveList = []

      const xValues = []
      const y1Values = []
      const y2Values = []
      const y1StdDevAreaHigh = []
      const y1StdDevAreaLow = []
      const splitData = data.toString().split('\n')

      for (let i = 0; i < splitData.length; i++) {
        const line = splitData[i].trim()
        const splitLine = line.split(/\s*[\s,]\s*/)
        if (splitLine.length === 4) {
          xValues.push(splitLine[0])
          y1Values.push(splitLine[1])
          y1StdDevAreaHigh.push(Number(splitLine[1]) - Number(splitLine[2]))
          y1StdDevAreaLow.push(Number(splitLine[1]) + Number(splitLine[2]))
          y2Values.push(splitLine[3])
        }
      }

      /* the curves shown in the graph */
      curveList.push(
        {
          x: xValues,
          y: y1Values,
          type: 'scatter',

          mode: 'lines',
          name: 'I(exp)',
          showlegend: true,
          marker: { color: '#FF0000' },
        },
        {
          x: xValues,
          y: y2Values,
          type: 'scatter',

          mode: 'lines',
          name: 'I(sim)',
          showlegend: true,
          marker: { color: '#0000FF' },
        },
        {
          x: xValues.concat(cloneDeep(xValues).reverse()),
          y: y1StdDevAreaHigh.concat(y1StdDevAreaLow.reverse()),
          type: 'scatter',

          fill: 'tozerox',
          fillcolor: 'rgba(255,0,255,0.2)',
          line: { color: 'transparent' },
          showlegend: false,
        }
      )

      /* the graph layout */
      const layout = {
        title: '',
        xaxis: {
          title: 'q(nm<sup>-1</sup>)',
        },
        autosize: true,
      }

      const config = {
        // responsive: true,
        // autosizable: true
      }

      return (
        <Plot
          divId="firDataDiv"
          data={curveList}
          layout={layout}
          config={config}
          useResizeHandler
          onAutoSize={this.onAutoSize}
        />
      )
    }
    return null
  }

  onAutoSize() {
    const graphElement = document.getElementById('firDataDiv')
    if (graphElement) {
      this.height = graphElement.parentNode.offsetHeight
      this.width = graphElement.parentNode.offsetWidth
      Plotly.relayout('firDataDiv', {
        width: this.width,
        height: 400,
      })
    }
  }
}

export default FirContentPlotter

FirContentPlotter.propTypes = {
  /** csv data */
  data: PropTypes.string,
}
